export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6221.1c8b1dc9.jpg";